import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '../../Box/index.js';

var DatePickerModeToggleButton = function (props) {
    return (jsx(Box, __assign({ component: "button", "data-date-picker-mode-toggle-button": true, themeKey: "datePickerModeToggleButton" }, props)));
};

export { DatePickerModeToggleButton };
//# sourceMappingURL=DatePickerModeToggleButton.js.map
